import { useMemo } from 'react';
import { useSessionOrThrow } from './use-session';

function useIsImpersonating() {
    const session = useSessionOrThrow();

    const isImpersonating = useMemo(() => session.isImpersonating, [session.isImpersonating]);

    return isImpersonating;
}

export { useIsImpersonating };
